import React from 'react';
import { NavLink } from 'react-router-dom';


var bnr1 = require('./../../images/background/bg-5.png');


class Specialization extends React.Component {
    render() {
        return (
            <>
                <div dir='RTL' className="section-full mobile-page-padding bg-white p-t80 p-b30 bg-repeat square_shape1" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                                <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/pic1.jpg')} alt=""/>
                                        <div className="figcaption">
                                            <h4 style={{ fontFamily: 'Cairo, sans-serif', fontSize: '16px' , fontWeight : 'bold' }}>البناء و التشييد</h4>
                                            <p style={{ fontFamily: 'Cairo, sans-serif', fontSize: '12px' }}>نُبدع في هندسة أحلامك </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4  col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/pic2.jpg')} alt="" />
                                        <div className="figcaption">
                                            <h4>العمارة فنّنا</h4>
                                            <p>والابتكار أسلوبنا</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4  col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/pic3.jpg')} alt="" />
                                        <div className="figcaption bg-dark">
                                            <h4>رؤيتك مصدر إلهامنا</h4>
                                            <p>وإتقاننا هو وعدنا</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-12 col-sm-6 m-b30">
                                    <div className="mt-box our-speciallization-content">
                                        <h3 className="m-t0" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px' , fontWeight : 'bold' }} ><span >نبنيه</span> <br />بشكل أفضل.</h3>
                                        <p style={{ fontFamily: 'Cairo, sans-serif', fontSize: '18px' , lineHeight: '2' }} >عندما يتعلق الأمر بمنزلك، لا تعبث مع الباقين، ثق بالأفضل تحقيق رؤيتك هو ما نقوم به.
                                        . </p>
                                        <NavLink to="/project-grid"  className="site-button btn-effect" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '16px' }} >شاهد المزيد</NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                 
                </div>
            </>
        );
    }
};

export default Specialization;